(() => {
  const ERROR_TEXT =
    'Please select a strength before adding this product to your cart.';

  let userHasChosenStrength = false;
  let mutationTimer = null;

  /**
   * 查找 Strength 选项区域。
   */
  function getStrengthGroup() {
    const allControls = Array.from(
      document.querySelectorAll(
        'input[type="radio"], select'
      )
    );

    const namedStrengthControl = allControls.find((control) => {
      const attributes = [
        control.name,
        control.id,
        control.dataset.optionName,
        control.getAttribute('aria-label'),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return attributes.includes('strength');
    });

    if (namedStrengthControl) {
      return (
        namedStrengthControl.closest(
          [
            'fieldset',
            '.product-form__input',
            '.variant-picker__option',
            '.product-option',
            '.variant-option',
            '[data-option-name]',
            '[data-option]',
          ].join(',')
        ) || namedStrengthControl.parentElement
      );
    }

    const possibleGroups = Array.from(
      document.querySelectorAll(
        [
          'fieldset',
          '.product-form__input',
          '.variant-picker__option',
          '.product-option',
          '.variant-option',
          '[data-option-name]',
          '[data-option]',
        ].join(',')
      )
    );

    return (
      possibleGroups.find((group) => {
        const heading = group.querySelector(
          [
            'legend',
            '.form__label',
            '.product-form__label',
            '.option-label',
            '[class*="label"]',
          ].join(',')
        );

        const headingText = String(
          heading?.textContent || ''
        )
          .replace(':', '')
          .trim()
          .toLowerCase();

        return headingText === 'strength';
      }) || null
    );
  }

  function getStrengthControls() {
    const group = getStrengthGroup();

    if (!group) {
      return [];
    }

    return Array.from(
      group.querySelectorAll(
        'input[type="radio"], select'
      )
    );
  }

  function hasStrengthSelection() {
    return getStrengthControls().some((control) => {
      if (control.matches('input[type="radio"]')) {
        return control.checked && !control.disabled;
      }

      if (control.tagName === 'SELECT') {
        return Boolean(control.value);
      }

      return false;
    });
  }

  /**
   * 清除主题自动选中的默认 Strength。
   */
  function clearDefaultStrength() {
    if (userHasChosenStrength) {
      return;
    }

    const group = getStrengthGroup();

    if (!group) {
      return;
    }

    getStrengthControls().forEach((control) => {
      if (control.matches('input[type="radio"]')) {
        control.checked = false;
        control.removeAttribute('checked');
      }

      if (control.tagName === 'SELECT') {
        let placeholder = control.querySelector(
          'option[data-strength-placeholder="true"]'
        );

        if (!placeholder) {
          placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Select strength';
          placeholder.disabled = true;
          placeholder.dataset.strengthPlaceholder = 'true';
          control.prepend(placeholder);
        }

        control.value = '';
        placeholder.selected = true;
      }
    });

    group
      .querySelectorAll(
        [
          'label.active',
          'label.selected',
          'label.is-active',
          'label.is-selected',
          'button.active',
          'button.selected',
          'button.is-active',
          'button.is-selected',
          '[role="radio"][aria-checked="true"]',
          '[aria-pressed="true"]',
        ].join(',')
      )
      .forEach((element) => {
        element.classList.remove(
          'active',
          'selected',
          'is-active',
          'is-selected'
        );

        if (element.hasAttribute('aria-checked')) {
          element.setAttribute('aria-checked', 'false');
        }

        if (element.hasAttribute('aria-pressed')) {
          element.setAttribute('aria-pressed', 'false');
        }
      });

    updateDynamicCheckout();
  }

  function isPurchaseButton(target) {
    const button = target.closest(
      [
        'button',
        'input[type="submit"]',
        'a',
        '[role="button"]',
      ].join(',')
    );

    if (!button) {
      return null;
    }

    if (button.closest('.shopify-payment-button')) {
      return button;
    }

    const buttonName = String(
      button.getAttribute('name') || ''
    ).toLowerCase();

    const buttonText = String(
      button.textContent ||
        button.value ||
        button.getAttribute('aria-label') ||
        ''
    )
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const matchesPurchaseAction =
      buttonName === 'add' ||
      buttonText.includes('add to cart') ||
      buttonText.includes('buy it now') ||
      buttonText.includes('buy with') ||
      buttonText.includes('more payment options');

    return matchesPurchaseAction ? button : null;
  }

  /**
   * 未选择 Strength 时隐藏快速付款按钮。
   */
  function updateDynamicCheckout() {
    const shouldShow =
      userHasChosenStrength && hasStrengthSelection();

    document
      .querySelectorAll('.shopify-payment-button')
      .forEach((paymentButton) => {
        if (!shouldShow) {
          if (
            paymentButton.dataset
              .strengthOriginalDisplay === undefined
          ) {
            paymentButton.dataset.strengthOriginalDisplay =
              paymentButton.style.display || '';
          }

          paymentButton.style.display = 'none';
          return;
        }

        paymentButton.style.display =
          paymentButton.dataset.strengthOriginalDisplay || '';

        delete paymentButton.dataset
          .strengthOriginalDisplay;
      });
  }

  function clearError() {
    const group = getStrengthGroup();
    const message = document.querySelector(
      '.strength-required-message'
    );

    group?.classList.remove(
      'strength-required-error'
    );

    if (message) {
      message.hidden = true;
    }
  }

  function showError() {
    const group = getStrengthGroup();

    if (!group) {
      window.alert(ERROR_TEXT);
      return;
    }

    let message = document.querySelector(
      '.strength-required-message'
    );

    if (!message) {
      message = document.createElement('div');
      message.className =
        'strength-required-message';
      message.setAttribute('role', 'alert');
      message.setAttribute(
        'aria-live',
        'assertive'
      );

      group.insertAdjacentElement(
        'afterend',
        message
      );
    }

    message.textContent = ERROR_TEXT;
    
    message.style.setProperty('color', '#e53935', 'important');
message.style.setProperty('font-weight', '600', 'important');

    message.hidden = false;

    group.classList.add(
      'strength-required-error'
    );

    group.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    const firstControl = getStrengthControls()[0];
    firstControl?.focus();

    showToast(ERROR_TEXT);
  }

  function showToast(messageText) {
    let toast = document.getElementById(
      'strength-required-toast'
    );

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'strength-required-toast';
      toast.className =
        'strength-required-toast';
      toast.setAttribute('role', 'alert');
      toast.setAttribute(
        'aria-live',
        'assertive'
      );

      document.body.appendChild(toast);
    }

    toast.textContent = messageText;
    toast.classList.add('is-visible');

    window.clearTimeout(toast.hideTimer);

    toast.hideTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 3000);
  }

  function selectionIsValid() {
    return (
      userHasChosenStrength &&
      hasStrengthSelection()
    );
  }

  /**
   * 记录用户主动点击 Strength。
   */
  document.addEventListener(
    'pointerdown',
    (event) => {
      const group = getStrengthGroup();

      if (!group || !group.contains(event.target)) {
        return;
      }

      const optionControl = event.target.closest(
        [
          'label',
          'input[type="radio"]',
          'select',
          '[role="radio"]',
        ].join(',')
      );

      if (optionControl) {
        userHasChosenStrength = true;
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const group = getStrengthGroup();

      if (
        !group ||
        !group.contains(event.target)
      ) {
        return;
      }

      if (
        event.target.matches(
          'input[type="radio"], select'
        )
      ) {
        userHasChosenStrength = true;
        clearError();

        window.setTimeout(
          updateDynamicCheckout,
          0
        );
      }
    },
    true
  );

  /**
   * 拦截 AJAX 加购按钮。
   */
  document.addEventListener(
    'click',
    (event) => {
      const group = getStrengthGroup();

      if (!group) {
        return;
      }

      const purchaseButton =
        isPurchaseButton(event.target);

      if (!purchaseButton) {
        return;
      }

      if (selectionIsValid()) {
        clearError();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showError();
    },
    true
  );

  /**
   * 拦截普通 Shopify 产品表单提交。
   */
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      const isProductForm =
        form.matches(
          'form[action*="/cart/add"]'
        ) ||
        form.matches(
          'form.shopify-product-form'
        );

      if (!isProductForm) {
        return;
      }

      if (selectionIsValid()) {
        clearError();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showError();
    },
    true
  );

  function initialize() {
    clearDefaultStrength();
    updateDynamicCheckout();

    /**
     * 兼容产品插件或订阅插件延迟加载。
     */
    [100, 300, 700, 1200, 2000, 3500].forEach(
      (delay) => {
        window.setTimeout(() => {
          clearDefaultStrength();
          updateDynamicCheckout();
        }, delay);
      }
    );

    /**
     * Style、Pack Size 或订阅组件变化时，
     * 防止主题重新默认选择 Strength。
     */
    const observer = new MutationObserver(() => {
      window.clearTimeout(mutationTimer);

      mutationTimer = window.setTimeout(() => {
        if (!userHasChosenStrength) {
          clearDefaultStrength();
        }

        updateDynamicCheckout();
      }, 50);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();